import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { IonContent, NavController, NavParams } from '@ionic/angular';
import { Navigator } from 'src/app/components/menu/navigator';
import { CustomerModel } from 'src/app/models/customer-model';
import { AppLinksService } from 'src/app/services/applinks/app-links.service';
import { AuthenticationService } from 'src/app/services/authentication/authentication.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { PASSWORD_PATTERN } from 'src/app/services/customFormValidators';
import { EventsService } from 'src/app/services/event/event.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { UserSessionService } from 'src/app/services/user-session/user-session.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-reset-boyd-password',
  templateUrl: './reset-boyd-password.component.html',
  styleUrls: ['./reset-boyd-password.component.scss'],
})
export class ResetBoydPasswordComponent implements OnInit {
    @ViewChild(IonContent, { static: false }) content: IonContent;


  public passwordPath;
  public loginUrl;
  public error: any = null;
  public resetPasswordForm: FormGroup;

  public customer: CustomerModel;

  public passwordGroup: AbstractControl;
  public newPassword: AbstractControl;
  public confirmPassword: AbstractControl;
  public securityGroup: AbstractControl;
  public securityAnswer: AbstractControl;
  public secondSecurityAnswer: AbstractControl;
  public showPasswordReset:boolean;
  public hasToken:boolean;
  public securityQuestionFirst: any;
  public securityQuestionTwo: any;
  public customerid:any;
  public showForm:boolean = true;
  public updateSuccess:boolean = false;
  public showIncomplete:boolean = false;
  public showPassword:boolean;
  public showConfirmPassword:boolean;
  public boydLoginURL: any;
  isAuthenticated: boolean;




  constructor(
      public navCtrl: NavController,
      public navParams: NavParams,
      public userSession: UserSessionService,
      public successMessageProvider: SuccessMessageService,
      public config: ConfigService,
      public utils: UtilsService,
      public navigator: Navigator,
      public authenticationService: AuthenticationService,
      private appLinks: AppLinksService
  ) {
    this.verifyAuth();
      this.successMessageProvider.clearMessage();
      this.loginUrl = `${this.config.getConfig().LOBBY_URL}?r=0#load-dialog=login`;
  }

  ngOnInit() {
    this.passwordPath = this.isAuthenticated ? 'change-password' : 'forgot-password';
    this.boydLoginURL = this.config.getConfig().FEATURE_BOYD_LOGIN_URL ? this.config.getConfig().FEATURE_BOYD_LOGIN_URL : 'https://rewards.boydgaming.com/' 
  }


  private verifyAuth(): any {
    this.userSession.isAuthenticated().then((auth) => {
      if (auth) return this.isAuthenticated = true;
      return this.isAuthenticated = false;
    })
  }

  goToBoyd(){
    this.appLinks.openExternalPage(this.boydLoginURL);
  }

 
}
